import React from 'react';
import {
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  Button,
  Box,
  AppBar,
  Tabs,
  Tab,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  IconButton,
  Snackbar, Divider,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import SchoolIcon from '@mui/icons-material/School';
import PaidIcon from '@mui/icons-material/Paid';
import PublicIcon from '@mui/icons-material/Public';
import LiveHelpIcon from '@mui/icons-material/LiveHelp';
import EmojiPeopleIcon from '@mui/icons-material/EmojiPeople';
import CheckCircleIcon from '@mui/icons-material/CheckCircle'; // CheckCircle icon for better visual representation
import EventIcon from '@mui/icons-material/EventAvailable';
import ActivitiesIcon from '@mui/icons-material/Star';
// import ausdegree from '../img/ausdegree.jpeg';
import ausdegree from '../img/ausdegree.jpg'
import Webhead from '../Webhead';
import { useState } from 'react';
import Webfoot from '../Webfoot';


const Raustralia = () => {

  const [value, setValue] = useState(0);
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  const handleTabChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const benefits = [
    {
      title: "World’s leading economy",
      description: "A top choice for Indian students seeking global education.",
      icon: <PaidIcon />
    },
    {
      title: "Cosmopolitan cities with great quality of life",
      description: "Earn globally recognized and accredited qualifications.",
      icon: <SchoolIcon />
    },
    {
      title: "Immense demand for workers of all skills",
      description: "Protective rights and support for international students.",
      icon: <PublicIcon />
    },
    {
      title: "Melting pot of cultures",
      description: "Experience a rich cultural and linguistic diversity.",
      icon: <EmojiPeopleIcon />
    },
    {
      title: "Huge opportunity for professional growth",
      description: "Government-provided financial aid for students.",
      icon: <LiveHelpIcon />
    },
    {
      title: "High salaries with incredible savings",
      description: "Thriving economy with promising job opportunities.",
      icon: <SchoolIcon />
    },
  ];

  return (
    <div>
      <Webhead />
      <div>
        {/* <StudyInAustralia /> */}
        <Container maxWidth="lg" style={{ marginTop: '20px', marginBottom: '40px' }}>

          <Box
            sx={{
              backgroundImage: `url(${ausdegree})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              color: 'white',
              padding: '100px 20px',
              textAlign: 'center',
            }}
          >
            <Typography variant="h4" gutterBottom>
              Pursue Your Dream In Australia
            </Typography>
            <Typography variant="h6" paragraph>
              Accelerate Your Career With An Australian Education
            </Typography>
            <Button variant="contained" color="primary" onClick={() => setSnackbarOpen(true)}>
              Get Started
            </Button>
          </Box>

          {/* Tabs for Different Sections */}
          <AppBar position="static" color="default">
            <Tabs value={value} onChange={handleTabChange} aria-label="tabs">
              <Tab label="Why Migrate To The US?" />
              {/* <Tab label="Admission Process" /> */}
              {/* <Tab label="Student Life" /> */}
            </Tabs>
          </AppBar>

          {/* Tab Content */}
          {value === 0 && (
            <Box sx={{ padding: '5px 0' }}>
              <br />
              <Box sx={{ padding: '20px', backgroundColor: '#F9BB16', borderRadius: '8px', textAlign: 'center' }}>
                <Typography variant="h4" sx={{ fontWeight: 'bold', color: 'black' }}>
                  Study In Australia
                </Typography>
              </Box>
              <br />
              <Typography variant="h6" sx={{ fontWeight: 'bold', color: 'black' }}>

                Life In Australia
              </Typography>
              <Typography variant="body1" paragraph>
                With sunny beaches, vibrant cities and a welcoming culture, Australia is one of the world’s most desired migration destinations. Qualified professionals from across the world are flocking to Australia for its great quality of life and stable economic prospects. An English speaking country, Australia is not just easy to assimilate into but also has a more cosmopolitan culture thanks to a significant migrant population. It’s enviable citizen benefits and progressive policies make it a great destination to settle with your family.
              </Typography>
              <Typography variant="h5" sx={{ fontWeight: 'bold', color: 'black' }}>

                Why Should You Settle In Australia?
              </Typography>
              <br />
              <Grid container spacing={2} justifyContent="center">

                {benefits.map((benefit, index) => (
                  <Grid item xs={6} sm={6} md={6} key={index}>
                    <Card variant="outlined" sx={{ display: 'flex', alignItems: 'center', padding: '16px', boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)', borderRadius: '8px' }}>
                      <IconButton color="primary" sx={{ marginRight: '16px' }}>
                        {benefit.icon}
                      </IconButton>
                      <CardContent sx={{ flex: 1 }}>
                        <Typography variant="h6" gutterBottom>
                          {benefit.title}
                        </Typography>
                        {/* Uncomment below line if you want to include the description */}
                        {/* <Typography variant="body2">{benefit.description}</Typography> */}
                      </CardContent>
                    </Card>
                  </Grid>
                ))}
              </Grid>
            </Box>
          )}

          {value === 1 && (
            <Box sx={{ padding: '20px', borderRadius: '8px', backgroundColor: '#fafafa' }}>
              <Typography variant="h5" sx={{ fontWeight: 'bold', marginBottom: 2 }}>
                Admission Process
              </Typography>
              <Typography variant="body1" paragraph>
                The admission process for studying in Australia typically includes the following steps:
              </Typography>
              <ul style={{ listStyleType: 'none', padding: 0 }}>
                {[
                  "Choose a program and institution.",
                  "Check the admission requirements.",
                  "Prepare required documents (transcripts, letters of recommendation, etc.).",
                  "Submit your application online.",
                  "Receive an acceptance letter and pay tuition fees.",
                  "Apply for a study permit.",
                ].map((step, index) => (
                  <li key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: '10px', padding: '10px', border: '1px solid #ccc', borderRadius: '5px', backgroundColor: '#fff' }}>
                    <SchoolIcon color="primary" style={{ marginRight: '10px' }} />
                    <Typography variant="body1">{step}</Typography>
                  </li>
                ))}
              </ul>
            </Box>
          )}

          {value === 2 && (
            <Box sx={{ padding: '20px', borderRadius: '8px', backgroundColor: '#fafafa', marginTop: 4 }}>
              <Typography variant="h5" sx={{ fontWeight: 'bold', marginBottom: 2 }}>
                Student Life
              </Typography>
              <Typography variant="body1" paragraph>
                Student life in Australia is diverse and vibrant. You can expect to engage in:
              </Typography>
              <ul style={{ listStyleType: 'none', padding: 0 }}>
                {[
                  "Participating in clubs and organizations.",
                  "Attending social events and networking opportunities.",
                  "Enjoying the cultural and recreational activities in your area.",
                ].map((activity, index) => (
                  <li key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: '10px', padding: '10px', border: '1px solid #ccc', borderRadius: '5px', backgroundColor: '#fff' }}>
                    <EventIcon color="primary" style={{ marginRight: '10px' }} />
                    <Typography variant="body1">{activity}</Typography>
                  </li>
                ))}
              </ul>
            </Box>
          )}

          <Box sx={{ padding: '20px' }}>
            {/* Heading: How To Settle In Australia */}
            <Typography variant="h5" sx={{ fontWeight: 'bold', marginBottom: 2 }}>
              How To Settle In Australia?
            </Typography>
            <Divider sx={{ marginBottom: 2 }} />
            <Typography variant="body1" paragraph>
              Australia’s pioneering immigration department has streamlined the application process to reduce processing time. However, a comprehensive and accurate application package is vital to taking advantage of this. With a dedicated Australia migration team, Trent International has the knowledge and experience to help you file an application with the highest chances of success. Our team of RMA certified professionals in our Australian partner office can assess your application and help you file it with confidence.
            </Typography>
            <Divider sx={{ marginBottom: 2 }} />

            {/* Heading: Who Is Eligible To Apply To Australia? */}
            <Typography variant="h5" sx={{ fontWeight: 'bold', marginBottom: 2 }}>
              Who Is Eligible To Apply To Australia?
            </Typography>
            <Divider sx={{ marginBottom: 2 }} />
            <Typography variant="body1" paragraph>
              While each program to migrate to Australia has different criteria, there are a few things in common.
            </Typography>
            <ul style={{ padding: 0 }}>
              {[
                "Education",
                "Experience",
                "PTE Score",
                "Documents & Proofs",
              ].map((item, index) => (
                <li key={index}>
                  <Typography variant="body1"> {item}</Typography>
                </li>
              ))}
            </ul>
          </Box>

          {/* Snackbar for user feedback */}
          <Snackbar
            open={snackbarOpen}
            onClose={handleSnackbarClose}
            message="Get Started button clicked!"
            autoHideDuration={4000}
          />
        </Container>
      </div>
      <Webfoot />
    </div>
  );
};

export default Raustralia;